import { useState, type FormEvent } from 'react'
import { Button } from '../components/ui'
import { useAuth } from '../lib/auth'
import { errorMessage } from '../lib/errors'
import { APP_NAME, supabase } from '../lib/supabase'

export function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [info, setInfo] = useState<string | null>(null)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await signIn(email.trim(), password)
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  async function reset() {
    if (!email.trim()) {
      setError('Escriba su correo para enviarle el enlace de recuperación.')
      return
    }
    setBusy(true)
    const { error: e } = await supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo: window.location.origin })
    setBusy(false)
    if (e) setError(errorMessage(e))
    else setInfo('Si el correo existe, recibirá un enlace para restablecer la contraseña.')
  }

  return (
    <div className="center-page login-bg">
      <form className="login-card" onSubmit={submit}>
        <img src="/favicon.svg" alt="" width={56} height={56} />
        <h1>{APP_NAME}</h1>
        <p className="muted">Panel administrativo</p>
        <label className="field">
          <span>Correo electrónico</span>
          <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>Contraseña</span>
          <input type="password" autoComplete="current-password" required minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error ? <div className="state state-error" role="alert">{error}</div> : null}
        {info ? <div className="state state-info" role="status">{info}</div> : null}
        <Button type="submit" busy={busy} className="w-full">Ingresar</Button>
        <button type="button" className="link" onClick={() => void reset()} disabled={busy}>Olvidé mi contraseña</button>
      </form>
    </div>
  )
}
